const STORAGE_KEY = 'academia_cortex_form_data_v1';
const SESSION_KEY = 'academia_cortex_session_id';

const createFallbackId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;

const scopedKey = (baseKey, scope = 'classic') => {
  if (!scope || scope === 'classic') return baseKey;
  return `${baseKey}_${scope}`;
};

export const getSessionId = (scope = 'classic') => {
  try {
    const key = scopedKey(SESSION_KEY, scope);
    const existing = localStorage.getItem(key);
    if (existing) return existing;

    const generated = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : createFallbackId();

    localStorage.setItem(key, generated);
    return generated;
  } catch (error) {
    // In private mode or blocked storage, keep app functional in-memory.
    return createFallbackId();
  }
};

export const setSessionId = (sessionId, scope = 'classic') => {
  const cleanSessionId = String(sessionId || '').trim();
  if (cleanSessionId.length < 8) return false;
  try {
    localStorage.setItem(scopedKey(SESSION_KEY, scope), cleanSessionId);
    return true;
  } catch (error) {
    return false;
  }
};

export const loadFromLocalStorage = (scope = 'classic') => {
  try {
    const raw = localStorage.getItem(scopedKey(STORAGE_KEY, scope));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const saveToLocalStorage = (data = {}, scope = 'classic') => {
  try {
    const previous = loadFromLocalStorage(scope) || {};
    const next = {
      ...previous,
      ...data,
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(scopedKey(STORAGE_KEY, scope), JSON.stringify(next));
    return next;
  } catch (error) {
    return null;
  }
};

export const clearLocalStorage = (scope = 'classic') => {
  try {
    localStorage.removeItem(scopedKey(STORAGE_KEY, scope));
  } catch (error) {
    // no-op
  }
};
